import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import default_image_url from '../../../../redux/api/API'
import './style.scss'

const ExpoLink = (props) => {
    const {t} = useTranslation();

    return (
        <div className='expo-link'>
            <Container>
                <Row className='homepagehallslink my-5'>
                    <div className='col-lg-7 expo-image' style={{background: 'url(/assets/img/expo-link.jpg)'}} alt="exhibition">
                        <div className='expo-content'>
                            <h4 className='mb-3 text-center'>{t("visit_online_exhibition")}</h4>
                            <p>{t("You can visit the virtual exhibition for free through the following link")}</p>
                            <Link to='/exhibition' target="_blank" className='btn btn-lg purple-btn'>{t("visit the exhibition")}</Link>
                        </div>
                    </div>
                    {props.ads.filter(item => item.location === 'homepage' & item.position === 'expoLinkSide').map(ad => (
                        <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='col-lg-5 link-add-container'>
                            <img src={default_image_url+ad.path} alt={ad.url} />
                        </a>
                    ))}
                </Row>
            </Container>
        </div>
    )
}

export default ExpoLink
